import { render } from "./ListAgendaSubKomunitasView.vue?vue&type=template&id=5b867682"
import script from "./ListAgendaSubKomunitasView.vue?vue&type=script&lang=js"
export * from "./ListAgendaSubKomunitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__